import theme from "@theme";
import { Icon } from "@thetreep/ui";

export function GhgTag({ value }: { value: number }) {
  return (
    <div
      className="bg-kpi-turquoise-soft flex items-center gap-1 rounded-xl py-1 px-2 whitespace-nowrap
"
    >
      <Icon
        src="leaf_line"
        color={theme.colors.kpi.turquoise.strong}
        size={12}
      />
      <span className="text-kpi-turquoise-strong text-xs font-bold">
        {value / 1000}kg CO2e
      </span>
    </div>
  );
}
